import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, UIText2 } from '@cian/ui-kit';
import { openAuthorizationModal } from '../../redux';

import { redirect } from '../../utils';
import { selectIsAuthorized, selectDefaultRedirectUrl } from '../../selectors/calculator';
import { ETestIds } from '../../constants';

import * as styles from './styles.css';

export const ActionsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isAuthorized = useSelector(selectIsAuthorized);
  const defaultRedirectUrl = useSelector(selectDefaultRedirectUrl);

  const handleClick = () => {
    if (isAuthorized) {
      redirect(defaultRedirectUrl);

      return;
    }

    dispatch(openAuthorizationModal({ redirectUrl: defaultRedirectUrl }));
  };

  return (
    <div className={styles['btn']}>
      <div className={styles['wrapper']}>
        <Button size="M" onClick={handleClick} data-testid={ETestIds.MainButton}>
          Заполнить заявку на Циане
        </Button>
        <UIText2 color={'text-secondary-default'}>Заявка единая для всех банков</UIText2>
      </div>
    </div>
  );
};
